export const SET_CURRENT_FOOD_COURT = "SET_CURRENT_FOOD_COURT";
export const SET_CURRENT_FOOD_COURT_DETAILS = "SET_CURRENT_FOOD_COURT_DETAILS";
export const SET_CURRENT_RESTAURANT_DETAILS = "SET_CURRENT_RESTAURANT_DETAILS";

export const ADD_ITEM_TO_CART = "ADD_ITEM_TO_CART";
export const ADD_MULTIPLE_ITEMS_TO_CART = "ADD_MULTIPLE_ITEMS_TO_CART";
export const REMOVE_ITEM_FROM_CART = "REMOVE_ITEM_FROM_CART";
export const UPDATE_ITEMS_IN_CART = "UPDATE_ITEMS_IN_CART";
export const CLEAR_ITEMS_IN_CART = "CLEAR_ITEMS_IN_CART";

export const ADD_ITEM_TO_TEMP_CART = "ADD_ITEM_TO_TEMP_CART";
export const REMOVE_ITEM_TO_TEMP_CART = "REMOVE_ITEM_TO_TEMP_CART";
export const CLEAR_ITEMS_IN_TEMP_CART = "CLEAR_ITEMS_IN_TEMP_CART";

export const STORE_MENU_LIST = "STORE_MENU_LIST";
export const REDUCE_MENU_LIST = "REDUCE_MENU_LIST";
export const CLEAR_MENU_LIST = "CLEAR_MENU_LIST";

export const STORE_IMMUTABLE_MENU_LIST = "STORE_IMMUTABLE_MENU_LIST";
export const UPDATE_IMMUTABLE_MENU_ITEM_LIKE =
  "UPDATE_IMMUTABLE_MENU_ITEM_LIKE";
export const UPDATE_IMMUTABLE_MENU_ITEM_FAVORITE =
  "UPDATE_IMMUTABLE_MENU_ITEM_FAVORITE";

export const STORE_IMMUTABLE_SUBMENU = "STORE_IMMUTABLE_SUBMENU";

export const UPDATE_IMMUTABLE_MULTI_SUBMENU = "UPDATE_IMMUTABLE_MULTI_SUBMENU";
export const CLEAR_IMMUTABLE_MULTI_SUBMENU = "CLEAR_IMMUTABLE_MULTI_SUBMENU";

export const UPDATE_MULTI_RESTAURANT_DETAILS =
  "UPDATE_MULTI_RESTAURANT_DETAILS";
export const CLEAR_MULTI_RESTAURANT_DETAILS = "CLEAR_MULTI_RESTAURANT_DETAILS";

export const STORE_FOOD_COURTS_LIST = "STORE_FOOD_COURTS_LIST";
export const STORE_FOOD_COURT_SETTINGS = "STORE_FOOD_COURT_SETTINGS";

export const STORE_USER_DETAILS = "STORE_USER_DETAILS";
export const CLEAR_USER_DETAILS = "CLEAR_USER_DETAILS";

export const SET_CURRENT_SESSION = "SET_CURRENT_SESSION";
export const CLEAR_CURRENT_SESSION = "CLEAR_CURRENT_SESSION";

export const STORE_IMMUTABLE_FILTER_LIST = "STORE_IMMUTABLE_FILTER_LIST";

export const STORE_IMMUTABLE_ALLERGENS = "STORE_IMMUTABLE_ALLERGENS";

export const SET_ALLERGENS = "SET_ALLERGENS";

export const SET_SELECTED_DATE = "SET_SELECTED_DATE";
export const CLEAR_SELECTED_DATE = "CLEAR_SELECTED_DATE";

export const SET_ERROR_MESSAGE = "SET_ERROR_MESSAGE";
export const CLEAR_ERROR_MESSAGE = "CLEAR_ERROR_MESSAGE";

export const SET_SNACKBAR_MESSAGE = "SET_SNACKBAR_MESSAGE";
export const CLEAR_SNACKBAR_MESSAGE = "CLEAR_SNACKBAR_MESSAGE";

export const SET_SEARCH_TEXT = "SET_SEARCH_TEXT";
export const CLEAR_SEARCH_TEXT = "CLEAR_SEARCH_TEXT";

export const SET_FILTERS = "SET_FILTERS";
export const STORE_PAYMENT_OPTIONS = "STORE_PAYMENT_OPTIONS";

export const SET_SUCCESS_ORDER_ID = "SET_SUCCESS_ORDER_ID";
export const CLEAR_SUCCESS_ORDER_ID = "CLEAR_SUCCESS_ORDER_ID";

export const ASK_NOTIFICATION_PERMISSION = "ASK_NOTIFICATION_PERMISSION";
export const CLEAR_NOTIFICATION_PERMISSION = "CLEAR_NOTIFICATION_PERMISSION";
export const NOTIFICATION_POPUP_SHOWN = "NOTIFICATION_POPUP_SHOWN";

export const SHOW_ADD_TO_HOME_SCREEN = "SHOW_ADD_TO_HOME_SCREEN";
export const HIDE_ADD_TO_HOME_SCREEN = "HIDE_ADD_TO_HOME_SCREEN";

export const STORE_RESTAURANTS_LIST = "STORE_RESTAURANTS_LIST";

export const STORE_FOOD_AND_REC_URLS = "STORE_FOOD_AND_REC_URLS";
export const CLEAR_FOOD_AND_REC_URLS = "CLEAR_FOOD_AND_REC_URLS";

export const SET_FIREBASE_STATIC_DATA = "SET_FIREBASE_STATIC_DATA";
export const TOGGLE_FORCE_TRIGGER = "TOGGLE_FORCE_TRIGGER";

export const SET_SEARCH_NOTIFY = "SET_SEARCH_NOTIFY";
export const CLEAR_SEARCH_NOTIFY = "CLEAR_SEARCH_NOTIFY";

export const SET_SEARCH_DATA = "SET_SEARCH_DATA";
export const CLEAR_SEARCH_DATA = "CLEAR_SEARCH_DATA";

export const SET_SEARCH_DATA_LOADING = "SET_SEARCH_DATA_LOADING";

export const ADD_CAFE_PASS = "ADD_CAFE_PASS";
export const CLEAR_CAFE_PASS = "CLEAR_CAFE_PASS";
export const SET_ACTIVE_PASS = "SET_ACTIVE_PASS";

export const SET_SLOT_SHOW = "SET_SLOT_SHOW";

export const SET_SLOT_DISPLAY = "SET_SLOT_DISPLAY";

export const SET_PREORDER_DATA = "SET_PREORDER_DATA";

export const SET_SESSIONS_DATA = "SET_SESSIONS_DATA";



// WEBPACK FOOTER //
// ./src/store/actions.js